module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAArCAMAAAB1q+c0AAAAQlBMVEUAAAD443XlVRr45XbfWRriWBv75HfiVxv65XfiWBz65XfhWRviWBv65XfiWBvmbinyuFn43HH53XL53nL53nP65XciSxkUAAAADnRSTlMAJScnKK2t7+/x8fLz80uPK7AAAABqSURBVFjD7c2JEYAgAAOwgnyC8qjsv6pb0NNrFghgQp5r5WCALc310oYwGQIy5T0xOfTq1atXr169evXq1fuB96K0Dzrl7WiD0I6G2vq9eL17q6gcen/+7pT2gKe8Hi4S2ugA68vitXiLFytbhMKL78RBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/Button_n@2x.png
// module id = +fk8
// module chunks = 70